import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import ForecastDiarizado from "../../../components/classes/ForecastDiarizado";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import ForecastDiarizadoDataSet from "../../../components/data/ForecastDiarizadoDataSet";
import LogDataset from "../../../components/data/LogDataset";
import Log from "../../../components/classes/Log";
import Usuario from "../../../components/classes/Usuario";
/*
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
*/
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers'
import br from "date-fns/locale/pt-BR";

import { useTranslation } from "react-i18next";

export default function ForecastDiarioMoverPlanoModalDetalhe(
  props: ForecastDiarioMoverPlanoModalDetalhePropsTypes
) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [forecastsDiarizadosValidos, setForecastsDiarizadosValidos] = useState<
    ForecastDiarizado[]
  >(() => {
    let initialState: ForecastDiarizado[] = props.forecastsDiarizados?.filter(
      (forecast) => {
        return (
          forecast.anoMesRef >= props.forecastDiarizadoAtual.anoMesRef &&
          forecast.centro == props.forecastDiarizadoAtual.centro &&
          forecast.idSku == props.forecastDiarizadoAtual.idSku
        );
      }
    )!;
    return initialState;
  });
  const [forecastsDiarizadoAlvo, setForecastsDiarizadosAlvo] =
    useState<ForecastDiarizado>();

  const dataForecastDiarizado: ForecastDiarizadoDataSet =
    new ForecastDiarizadoDataSet();
  const logDataset: LogDataset = new LogDataset();

  useEffect(() => {
    if (isLoading) {
      updateForecasts();
    }
  }, [isLoading]);

  function handleForecastAlvoChange(dataSelecionada: Date): void {
    let forecastAlvo: ForecastDiarizado = forecastsDiarizadosValidos.find(
      (item: ForecastDiarizado) => {
        return (
          new Date(item.dia).toLocaleDateString("pt-br") ===
          dataSelecionada.toLocaleDateString("pt-br")
        );
      }
    )!;
    setForecastsDiarizadosAlvo(forecastAlvo);
  }

  function handleMoverPlanoClick(): void {
    setIsLoading(true);
  }

  async function updateForecasts(): Promise<void> {
    let isSuccess: boolean = false;
    let quantidadeASerMovida: number = props.forecastDiarizadoAtual.quantidade;
    props.forecastDiarizadoAtual.quantidade = 0;
    forecastsDiarizadoAlvo!.quantidade = quantidadeASerMovida;
    await dataForecastDiarizado
      .Atualizar(props.forecastDiarizadoAtual)
      .then((result) => {
        isSuccess = result ? true : false;
      });
    await dataForecastDiarizado
      .Atualizar(forecastsDiarizadoAlvo!)
      .then((result) => {
        isSuccess = result ? true : false;
      });

    if (isSuccess) {
      let log: Log = new Log();
      const usuario: Usuario = JSON.parse(
        String(localStorage.getItem("UsuarioCache"))
      );
      log.mensagemAlteracaoForecastDiario(
        Number(usuario.id),
        forecastsDiarizadoAlvo!.idSku,
        forecastsDiarizadoAlvo!.centro,
        props.forecastDiarizadoAtual.id.toString(),
        forecastsDiarizadoAlvo!.id.toString(),
        quantidadeASerMovida
      );
      await logDataset.add(log);
    }

    props.setPlanoFoiMovido({ isSuccess, wasUpdated: true });
    props.handleClose();
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          height={"40vh"}
          justifyContent={"space-between"}
          margin={"0.5rem"}
        >
          <Box>
            <h3>{t("pages.dailyForecast.text.whenToMoveProduction")}</h3>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  minDate={forecastsDiarizadosValidos[0].dia}
                  maxDate={
                    forecastsDiarizadosValidos[
                      forecastsDiarizadosValidos.length - 1
                    ].dia
                  }
                  inputFormat="dd/MM/yyyy"
                  label={t("pages.dailyForecast.text.forecastDate")}
                  value={
                    forecastsDiarizadoAlvo
                      ? forecastsDiarizadoAlvo?.dia
                      : props.forecastDiarizadoAtual.dia
                  }
                  onChange={(newValue: any) => {
                    handleForecastAlvoChange(newValue as Date);
                  }}
                  renderInput={(params: any) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </LocalizationProvider>

              {forecastsDiarizadoAlvo ? (
                <Box paddingTop={"1rem"}>
                  <Alert severity="warning">
                    {`${t("pages.dailyForecast.text.resetForecastForTheDay")} ${new Date(
                      props.forecastDiarizadoAtual.dia
                    ).toLocaleDateString("pt-br")}, ${t("pages.dailyForecast.text.movingQuantity")} ${props.forecastDiarizadoAtual.quantidade} ${t("pages.dailyForecast.text.fromSku")} ${props.forecastDiarizadoAtual.idSku
                      } ${t("pages.dailyForecast.text.forTheDay")} ${new Date(
                        forecastsDiarizadoAlvo.dia
                      ).toLocaleDateString("pt-br")}.`}
                  </Alert>
                </Box>
              ) : null}
            </FormControl>
          </Box>

          <Box
            paddingTop={"12px"}
            display={"flex"}
            justifyContent={"end"}
            alignSelf={"end"}
          >
            <Button
              variant="contained"
              onClick={handleMoverPlanoClick}
              disabled={!forecastsDiarizadoAlvo || isLoading}
            >
              {isLoading ? <CircularProgress size={24} /> : t("pages.dailyForecast.text.movePlan")}
            </Button>
          </Box>
        </Box>
      </LocalizationProvider>
    </>
  );
}

interface ForecastDiarioMoverPlanoModalDetalhePropsTypes {
  setPlanoFoiMovido: any;
  handleClose: any;
  forecastsDiarizados?: ForecastDiarizado[];
  forecastDiarizadoAtual: ForecastDiarizado;
}
